import { render, staticRenderFns } from "./oss.vue?vue&type=template&id=2ba46a4c&scoped=true"
import script from "./oss.vue?vue&type=script&lang=js"
export * from "./oss.vue?vue&type=script&lang=js"
import style0 from "./oss.vue?vue&type=style&index=0&id=2ba46a4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba46a4c",
  null
  
)

export default component.exports